/**
 * Legacy shim — fold into `#/lib/seo/jsonld/*`.
 *
 * Kept as a thin re-export so existing call sites (GenericDocPage,
 * existing tests) keep working without modification while the
 * codebase migrates to importing directly from `lib/seo/jsonld`.
 */
import { siteBaseUrl, siteName } from "#/lib/seo/site.js";

type ArticleSchema = {
  headline: string;
  description: string;
  url: string;
  inLanguage: string;
  dateModified: string;
  authorName: string;
  publisherName?: string;
  publisherUrl?: string;
};

export function buildArticleJsonLd(opts: ArticleSchema): object {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: opts.headline,
    description: opts.description,
    url: opts.url,
    inLanguage: opts.inLanguage,
    dateModified: opts.dateModified,
    author: {
      "@type": "Organization",
      name: opts.authorName,
    },
    publisher: {
      "@type": "Organization",
      name: opts.publisherName ?? siteName(),
      url: opts.publisherUrl ?? siteBaseUrl(),
    },
  };
}

export { JsonLdScript } from "#/lib/seo/jsonld/index.js";
